import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=7b7ef596&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=ts&"
export * from "./Login.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ef596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Romppu/source/repos/poker-serverless/pokerapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VImg,VLayout})
